<template>
  <PageManager :hideNavigation="true">
    <template #before-sidebar>
      <TemplateList :value="template" @input="setTemplate"/>
    </template>

    <template>
      <EmailTemplates
        v-if="website && show"

        :default="template"
        v-bind="bindTemplate"
      />
    </template>
  </PageManager>
</template>

<script>

import { mapGetters } from "vuex"

import TemplateList from "@/components/SideEditor/EmailTemplates/TemplateList"
import EmailTemplates from "@/components/SideEditor/EmailTemplates/EmailTemplates"
import PageManager from "@/components/SideEditor/PageManager"

export default {
  components: {
    PageManager,
    EmailTemplates,
    TemplateList,
  },
  data() {
    return {
      template: {},
      show: true,
    }
  },
  methods: {
    setTemplate(template) {
      // template
      this.show = false
      this.$nextTick(() => this.show = true)
      this.template = template
    },
  },
  computed: {
    ...mapGetters({
      website: "editor/website",
      config: 'editor/config',
    }),

    currentEmailConfig() {
      // config.email_templates[template.id
      if (!this.config || !this.config.email_templates || !this.config.email_templates || !this.config.email_templates[this.template.id]) return {}

      const options = this.config.email_templates[this.template.id]
      return {
        orig_template_code: options.orig_template_code || "",
        template_subject: options.template_subject || "",
        template: options.template,
      }
    },
    bindTemplate() {
      return {
        ...this.template,
        ...this.currentEmailConfig,
      }
    },
  },
}

</script>
